import { Typography } from "@mui/material";
import { Box, Stack, useMediaQuery } from "@mui/system";
import React from "react";

interface RoomSelectorProps {
  rooms: Array<{ numero: string; label: string; image: string }>;
  selectedRoom: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RoomSelector: React.FC<RoomSelectorProps> = ({
  rooms,
  selectedRoom,
  onChange,
}) => {
  return (
    <Stack>
      {rooms.map((room) => (
        <div key={room.numero}>
          <Box pb={2} display={"flex"} alignItems="center">
            <input
              type="radio"
              id={`room${room.numero}`}
              name="room"
              value={room.numero}
              checked={selectedRoom === room.numero}
              onChange={onChange}
              style={{ marginRight: "10px" }} // Optional for spacing
            />
            <label htmlFor={`room${room.numero}`} style={{ cursor: "pointer" }}>
              <Typography
                variant="body1"
                sx={{
                  fontSize: "18px",
                  fontFamily: "degular",
                  letterSpacing: 1.3,
                }}
              >
                {room.label}
              </Typography>
            </label>
          </Box>
        </div>
      ))}
    </Stack>
  );
};

export default RoomSelector;
